import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from './core/guards/auth.guard';
import { RouterModule, Routes } from '@angular/router';
import { Page401Component, Page404Component } from './extrapages';

const routes: Routes = [
  { path: '', loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule), canActivate: [AuthGuard] },
  { path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule), data: { title: 'account' } },
  { path: '401', component: Page401Component,  data: { title: '401 Page' } },
  { path: '404', component: Page404Component, data: { title: '404 Page' } },
  { path: '**', redirectTo: '404', pathMatch: 'full' }
];


@NgModule({
  imports: [CommonModule, RouterModule.forRoot(routes)],
  exports: [RouterModule],
  declarations: []
})
export class AppRoutingModule { }
